module.exports = "/images/CategoryButton.png?b98b52bad84757ad6812b65f05690ef9";